<template>
  <div class="container-pagetitle">
    <h3 class="tit-h4">{{ title }}</h3>
    <p v-if="subtitle" class="dim" v-html="subtitle" />
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
});
</script>

<style scoped lang="scss">
.container-pagetitle {
  display: flex;
  max-width: 40rem;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
